(function () {
  var activeFinishTrigger = null;

  function readJsonScripts(root, selector) {
    return Array.prototype.map.call(root.querySelectorAll(selector), function (node) {
      try {
        return JSON.parse(node.textContent || "{}");
      } catch (error) {
        return null;
      }
    }).filter(Boolean);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, "&#96;");
  }

  function sanitizeTitleHtml(value) {
    var template = document.createElement("template");
    var output = document.createElement("div");
    var allowedTags = {
      BR: true,
      EM: true,
      P: true
    };

    function appendCleanNode(node, parent) {
      var cleanNode;

      if (node.nodeType === Node.TEXT_NODE) {
        parent.appendChild(document.createTextNode(node.textContent || ""));
        return;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }

      if (!allowedTags[node.tagName]) {
        Array.prototype.forEach.call(node.childNodes, function (child) {
          appendCleanNode(child, parent);
        });
        return;
      }

      cleanNode = document.createElement(node.tagName.toLowerCase());
      if (node.tagName !== "BR") {
        Array.prototype.forEach.call(node.childNodes, function (child) {
          appendCleanNode(child, cleanNode);
        });
      }
      parent.appendChild(cleanNode);
    }

    template.innerHTML = String(value || "");
    Array.prototype.forEach.call(template.content.childNodes, function (node) {
      appendCleanNode(node, output);
    });

    return output.innerHTML;
  }

  function parseFilters(raw) {
    return String(raw || "")
      .split(/\r?\n/)
      .map(function (line) {
        var parts = line.split("|");
        if (parts.length < 2) return null;
        return {
          label: parts[0].trim(),
          key: parts[1].trim()
        };
      })
      .filter(function (filter) {
        return filter && filter.label && filter.key;
      });
  }

  function normalizeTag(tag) {
    var value = String(tag || "").trim().toLowerCase();
    if (value === "new" || value === "popular") return value;
    return "";
  }

  function getCollectionData(root) {
    var collections = {};
    readJsonScripts(root, "[data-cabinetry-collection-json]").forEach(function (collection) {
      if (!collection.key) return;
      collection.filters = parseFilters(collection.filters_raw);
      collections[collection.key] = collection;
    });

    var finishes = {};
    readJsonScripts(root, "[data-cabinetry-finish-json]").forEach(function (finish) {
      if (!finish.collection_key) return;
      if (!finishes[finish.collection_key]) finishes[finish.collection_key] = [];
      finish.filter_keys = String(finish.filter_keys || "all")
        .split(",")
        .map(function (key) { return key.trim(); })
        .filter(Boolean);
      finishes[finish.collection_key].push(finish);
    });

    return {
      collections: collections,
      finishes: finishes
    };
  }

  function buildFinishCard(finish, imageCrop) {
    var tag = normalizeTag(finish.tag);
    var cropClass = imageCrop === "face" || finish.image_crop === "face" ? " cabinetry-finish--face-crop" : "";
    var finishName = finish.name || "Door finish";
    var swatch = finish.image_url
      ? '<img src="' + escapeAttr(finish.image_url) + '" alt="' + escapeAttr(finish.image_alt || finishName) + '" loading="lazy" width="540" height="720">'
      : '<span class="cabinetry-finish__color" style="background:' + escapeAttr(finish.fallback_color || "#ddd") + ';"></span>';

    var tagHtml = tag
      ? '<span class="cabinetry-finish__tag cabinetry-finish__tag--' + tag + '">' + (tag === "new" ? "New" : "Popular") + '</span>'
      : "";

    return [
      '<article class="cabinetry-finish' + cropClass + '" role="button" tabindex="0" aria-label="View larger image of ' + escapeAttr(finishName) + '" data-filter-keys="' + escapeAttr((finish.filter_keys || ["all"]).join(",")) + '" data-finish-name="' + escapeAttr(finishName) + '" data-finish-short="' + escapeAttr(finish.short) + '" data-finish-price="' + escapeAttr(finish.price) + '" data-finish-lead="' + escapeAttr(finish.lead) + '" data-finish-image-url="' + escapeAttr(finish.image_url) + '" data-finish-zoom-url="' + escapeAttr(finish.image_zoom_url || finish.image_url) + '" data-finish-image-alt="' + escapeAttr(finish.image_alt || finishName) + '" data-finish-fallback-color="' + escapeAttr(finish.fallback_color || "#ddd") + '">',
        '<div class="cabinetry-finish__swatch">' + tagHtml + swatch + '</div>',
        '<div class="cabinetry-finish__top"><h4 class="cabinetry-finish__name">' + escapeHtml(finishName) + '</h4><span class="cabinetry-finish__lead">' + escapeHtml(finish.lead) + '</span></div>',
        '<div class="cabinetry-finish__detail"><p class="cabinetry-finish__short">' + escapeHtml(finish.short) + '</p><span class="cabinetry-finish__price">' + escapeHtml(finish.price) + '</span></div>',
      '</article>'
    ].join("");
  }

  function handleFinishViewerKeydown(event) {
    if (event.key === "Escape") closeFinishViewer();
  }

  function closeFinishViewer() {
    var viewer = document.querySelector(".cabinetry-finish-viewer");

    document.removeEventListener("keydown", handleFinishViewerKeydown);
    document.body.classList.remove("cabinetry-finish-viewer-open");

    if (viewer) viewer.remove();
    if (activeFinishTrigger && activeFinishTrigger.isConnected) {
      try {
        activeFinishTrigger.focus({ preventScroll: true });
      } catch (error) {
        activeFinishTrigger.focus();
      }
    }
    activeFinishTrigger = null;
  }

  function openFinishViewer(card) {
    var name = card.dataset.finishName || "Door finish";
    var shortDescription = card.dataset.finishShort || "";
    var price = card.dataset.finishPrice || "";
    var lead = card.dataset.finishLead || "";
    var imageUrl = card.dataset.finishZoomUrl || card.dataset.finishImageUrl || "";
    var imageAlt = card.dataset.finishImageAlt || name;
    var fallbackColor = card.dataset.finishFallbackColor || "#ddd";
    var visualHtml = imageUrl
      ? '<img src="' + escapeAttr(imageUrl) + '" alt="' + escapeAttr(imageAlt) + '">'
      : '<span class="cabinetry-finish-viewer__color" style="background:' + escapeAttr(fallbackColor) + ';"></span>';
    var viewer = document.createElement("div");

    closeFinishViewer();
    activeFinishTrigger = card;

    viewer.className = "cabinetry-finish-viewer";
    viewer.setAttribute("role", "dialog");
    viewer.setAttribute("aria-modal", "true");
    viewer.setAttribute("aria-label", "Larger finish image: " + name);
    viewer.innerHTML = [
      '<button class="cabinetry-finish-viewer__close" type="button" aria-label="Close enlarged finish image">&times;</button>',
      '<figure class="cabinetry-finish-viewer__panel">',
        '<div class="cabinetry-finish-viewer__media">' + visualHtml + '</div>',
        '<figcaption class="cabinetry-finish-viewer__caption">',
          '<div class="cabinetry-finish-viewer__meta"><span>' + escapeHtml(lead) + '</span><span>' + escapeHtml(price) + '</span></div>',
          '<h3 class="cabinetry-finish-viewer__title">' + escapeHtml(name) + '</h3>',
          '<p class="cabinetry-finish-viewer__text">' + escapeHtml(shortDescription) + '</p>',
        '</figcaption>',
      '</figure>'
    ].join("");

    viewer.addEventListener("click", function (event) {
      if (event.target === viewer) closeFinishViewer();
    });
    viewer.querySelector(".cabinetry-finish-viewer__close").addEventListener("click", closeFinishViewer);

    document.body.appendChild(viewer);
    document.body.classList.add("cabinetry-finish-viewer-open");
    document.addEventListener("keydown", handleFinishViewerKeydown);
    try {
      viewer.querySelector(".cabinetry-finish-viewer__close").focus({ preventScroll: true });
    } catch (error) {
      viewer.querySelector(".cabinetry-finish-viewer__close").focus();
    }
  }

  function buildTray(root, collectionKey, data) {
    var collection = data.collections[collectionKey];
    if (!collection) return null;

    var tray = document.createElement("div");
    var finishes = data.finishes[collectionKey] || [];
    var filters = collection.filters || [];
    var filterHtml = "";

    tray.className = "cabinetry-tray";
    tray.dataset.tray = collectionKey;

    if (filters.length > 1) {
      filterHtml = '<div class="cabinetry-tray__filters">' + filters.map(function (filter, index) {
        return '<button class="cabinetry-tray__filter' + (index === 0 ? ' is-active' : '') + '" type="button" data-tray-filter="' + escapeAttr(filter.key) + '">' + escapeHtml(filter.label) + '</button>';
      }).join("") + '</div>';
    }

    tray.innerHTML = [
      '<button class="cabinetry-tray__close" type="button" aria-label="Close finishes">&times;</button>',
      '<div class="cabinetry-tray__head">',
        '<div>',
          '<div class="cabinetry-tray__eyebrow">' + escapeHtml(collection.eyebrow) + '</div>',
          '<h3 class="cabinetry-tray__title">' + sanitizeTitleHtml(collection.title) + '</h3>',
        '</div>',
        '<div>',
          '<p class="cabinetry-tray__lead">' + escapeHtml(collection.lead) + '</p>',
          '<div class="cabinetry-tray__meta">' + escapeHtml(collection.meta) + '</div>',
        '</div>',
      '</div>',
      filterHtml,
      '<div class="cabinetry-tray__grid">',
        finishes.length ? finishes.map(function (finish) { return buildFinishCard(finish, collection.image_crop); }).join("") : '<p class="cabinetry-tray__empty">Finish details are coming soon.</p>',
      '</div>'
    ].join("");

    tray.querySelector(".cabinetry-tray__close").addEventListener("click", function (event) {
      event.stopPropagation();
      closeTray(root);
    });

    Array.prototype.forEach.call(tray.querySelectorAll("[data-tray-filter]"), function (button) {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        var key = button.dataset.trayFilter;

        Array.prototype.forEach.call(tray.querySelectorAll("[data-tray-filter]"), function (other) {
          other.classList.toggle("is-active", other === button);
        });

        Array.prototype.forEach.call(tray.querySelectorAll(".cabinetry-finish"), function (card) {
          var keys = (card.dataset.filterKeys || "all").split(",");
          card.hidden = key !== "all" && keys.indexOf(key) === -1;
        });
      });
    });

    Array.prototype.forEach.call(tray.querySelectorAll(".cabinetry-finish"), function (card) {
      card.addEventListener("click", function (event) {
        event.stopPropagation();
        openFinishViewer(card);
      });
      card.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          event.stopPropagation();
          openFinishViewer(card);
        }
      });
    });

    tray.addEventListener("click", function (event) {
      event.stopPropagation();
    });

    return tray;
  }

  function getGrid(root) {
    return root.querySelector("[data-cabinetry-catalog-grid]");
  }

  function closeTray(root) {
    var grid = getGrid(root);
    if (!grid) return;

    closeFinishViewer();

    var openCard = grid.querySelector(".cabinetry-door.is-open");
    var openTray = grid.querySelector(".cabinetry-tray");

    if (openCard) {
      openCard.classList.remove("is-open");
      openCard.setAttribute("aria-expanded", "false");
    }
    if (openTray) openTray.remove();
    grid.classList.remove("has-open");
  }

  function getColumnCount(grid) {
    var columns = window.getComputedStyle(grid).gridTemplateColumns.split(" ").filter(Boolean);
    return Math.max(1, columns.length);
  }

  function positionNotch(tray, card) {
    var trayRect = tray.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var cardCenter = cardRect.left + cardRect.width / 2;
    tray.style.setProperty("--notch-x", (cardCenter - trayRect.left) + "px");
  }

  function getVisibleHeaderOffset() {
    var header = document.querySelector(".shopify-section-header");
    var rect;

    if (!header || header.classList.contains("shopify-section-header-hidden")) return 0;

    rect = header.getBoundingClientRect();
    return Math.max(0, Math.min(rect.height, rect.bottom));
  }

  function afterLayout(callback) {
    if (!window.requestAnimationFrame) {
      window.setTimeout(callback, 32);
      return;
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(callback);
    });
  }

  function scrollToTray(tray) {
    afterLayout(function () {
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var targetY;

      if (!tray.isConnected) return;

      targetY = tray.getBoundingClientRect().top + window.pageYOffset - getVisibleHeaderOffset() - 8;
      window.scrollTo({
        top: Math.max(0, targetY),
        behavior: reducedMotion ? "auto" : "smooth"
      });
    });
  }

  function placeTrayAfterCardRow(root, tray, card) {
    var grid = getGrid(root);
    var visibleCards;
    var columnCount;
    var index;
    var rowEnd;
    var anchor;
    var nextNode;

    if (!grid || !tray || !card) return false;

    visibleCards = Array.prototype.filter.call(grid.querySelectorAll(".cabinetry-door"), function (door) {
      return !door.hidden;
    });
    index = visibleCards.indexOf(card);
    if (index === -1) return false;

    columnCount = getColumnCount(grid);
    rowEnd = Math.min(visibleCards.length - 1, Math.floor(index / columnCount) * columnCount + columnCount - 1);
    anchor = visibleCards[rowEnd];
    nextNode = anchor ? anchor.nextSibling : null;

    if (!anchor) return false;
    if (nextNode === tray) return true;
    if (nextNode) {
      grid.insertBefore(tray, nextNode);
    } else {
      grid.appendChild(tray);
    }

    return true;
  }

  function openTray(root, card, data) {
    var grid = getGrid(root);
    var collectionKey = card.dataset.collection;
    var wasOpen = card.classList.contains("is-open");
    var tray;

    if (!grid || !collectionKey) return;

    closeTray(root);
    if (wasOpen) return;

    tray = buildTray(root, collectionKey, data);
    if (!tray) return;

    card.classList.add("is-open");
    card.setAttribute("aria-expanded", "true");
    grid.classList.add("has-open");

    placeTrayAfterCardRow(root, tray, card);
    positionNotch(tray, card);
    scrollToTray(tray);
  }

  function applyCatalogFilter(root, filter) {
    closeTray(root);

    Array.prototype.forEach.call(root.querySelectorAll("[data-cabinetry-filter]"), function (button) {
      button.classList.toggle("is-active", button.dataset.cabinetryFilter === filter);
    });

    Array.prototype.forEach.call(root.querySelectorAll(".cabinetry-door"), function (card) {
      var profile = card.dataset.profile;
      var category = card.dataset.category;
      card.hidden = filter !== "all" && filter !== profile && filter !== category;
    });
  }

  function initCatalog(root) {
    var data = getCollectionData(root);

    Array.prototype.forEach.call(root.querySelectorAll(".cabinetry-door"), function (card) {
      card.addEventListener("click", function () {
        openTray(root, card, data);
      });
      card.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openTray(root, card, data);
        }
        if (event.key === "Escape") closeTray(root);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll("[data-cabinetry-filter]"), function (button) {
      button.addEventListener("click", function () {
        applyCatalogFilter(root, button.dataset.cabinetryFilter);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    Array.prototype.forEach.call(document.querySelectorAll("[data-cabinetry-catalog]"), initCatalog);

    window.addEventListener("resize", function () {
      Array.prototype.forEach.call(document.querySelectorAll("[data-cabinetry-catalog]"), function (root) {
        var tray = root.querySelector(".cabinetry-tray");
        var card = root.querySelector(".cabinetry-door.is-open");
        if (tray && card) {
          placeTrayAfterCardRow(root, tray, card);
          positionNotch(tray, card);
        }
      });
    });
  });
})();
